// import axios from "axios"
import router from '../../router';
import httpId from '@/service/http/http-id.js';
import http from '@/service/http/http.js';
import mainOidc from '../../service/oidc';
import store from '@/store';
import jwt from 'jsonwebtoken';

const state = {
  auth: null,
  pendingSocialAuth: null,
  tokenApi: null,
  loginLoading: false,
  loginError: '',
  registerCompleted: false
};

const mutations = {
  SET_AUTH: (state, value) => (value ? (state.auth = value) : (state.auth = null)),
  SET_PENDING_SOCIAL_AUTH: (state, value) => (state.pendingSocialAuth = value),
  COMMIT_SOCIAL_AUTH: (state) => {
    if (state.pendingSocialAuth) {
      state.auth = state.pendingSocialAuth;
      state.pendingSocialAuth = null;
    }
  },
  SET_LOGIN_LOADING: (state, value) => (value ? (state.loginLoading = value) : (state.loginLoading = false)),
  SET_LOGIN_ERROR: (state, value) => (value ? (state.loginError = value) : (state.loginError = '')),
  SET_REGISTER_COMPLETED: (state, value) => (value ? (state.registerCompleted = value) : (state.registerCompleted = false)),
  SET_TOKEN_API: (state, value) => (value ? (state.tokenApi = value) : (state.tokenApi = false))
};

const safeFirst = (value) => {
  if (!value || typeof value !== 'string') return '';
  const parts = value.split(' ');
  return parts[0] || '';
};

const getters = {
  getAuth: (state) => state.auth,
  getLoginLoading: (state) => state.loginLoading,
  getLoginError: (state) => state.loginError,
  getNomeUsuarioLogado: (state) => {
    if (!state.auth) return '';
    var profile = state.auth.profile || {};
    var fullName = profile.full_name || state.auth.full_name || '';
    return safeFirst(fullName);
  },
  getFotoUsuarioLogado: (state) => {
    if (!state.auth) return '';
    var profile = state.auth.profile || {};
    var pic = profile.picture;
    if (!pic) return '';
    if (Array.isArray(pic)) return pic[pic.length - 1] || '';
    return pic;
  },
  getRegisterCompleted: (state) => state.registerCompleted
};

const actions = {
  async setLoginGoogle() {
    await mainOidc.signIn({ acr_values: 'idp:Google' });

    return;
  },
  async setLoginFacebook() {
    await mainOidc.signIn({ acr_values: 'idp:Facebook' });

    return;
  },
  async logout({ commit }) {
    if (store.state.login.auth?.profile || store.state.login.auth?.id_token) {
      commit('SET_AUTH');
      // Mantém o cookie de MFA no logout: o estado real do MFA vive no Identity.
      // Apagar aqui forçaria o guard a re-descobrir o MFA a cada novo login.
      await mainOidc.signOut();
    } else {
      commit('SET_AUTH');
      router.push({ name: 'index' }).catch(() => {});
    }
  },

  async verificaAtivo({ commit }) {
    return new Promise((resolve, reject) => {
      http({
        url: `usuario/info`,
        method: 'get'
      })
        .then((resp) => {
          if (!resp.data.data.ativo && resp.data.data.cadastroCompleto) {
            commit('SET_AUTH');
            router.push({ name: 'login', params: { inativo: '' } });
          }
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  },

  setToken({ commit }) {
    const data = new URLSearchParams();
    data.append('client_id', 'site-eblonline');
    data.append('client_secret', '8FM48ML0gL8ulcME9uGk36uPgmQDGJJx');
    data.append('grant_type', 'client_credentials');
    return httpId
      .post('connect/token', data)
      .then((response) => {
        commit('SET_TOKEN_API', response.data);
      })
      .catch(() => {});
  },

  async setLogin({ commit, dispatch }, value) {
    commit('SET_LOGIN_LOADING', true);
    return new Promise((resolve, reject) => {
      mainOidc
        .signIn(value?.nomeUsuario ? { login_hint: value.nomeUsuario } : {})
        .then(async () => {
          await dispatch('verificaAtivo');
          commit('SET_LOGIN_ERROR', '');
          commit('SET_MENSAGEM', '');
          commit('SET_REGISTER_COMPLETED', true);
          commit('SET_LOGIN_LOADING');
          resolve();
        })
        .catch(function (error) {
          commit('SET_LOGIN_LOADING');
          const message = error?.error_description || error?.message || 'Erro Inesperado';
          if (message === 'invalid_username_or_password') commit('SET_LOGIN_ERROR', 'Email ou senha inválidos');
          else commit('SET_LOGIN_ERROR', message);
          reject();
        });
    });
  },

  async setLoginWithPassword({ commit }, value) {
    commit('SET_LOGIN_LOADING', true);
    return new Promise((resolve, reject) => {
      const data = new URLSearchParams();
      data.append('client_id', 'site-eblonline');
      data.append('client_secret', '8FM48ML0gL8ulcME9uGk36uPgmQDGJJx');
      data.append('grant_type', 'password');
      data.append('username', value.nomeUsuario);
      data.append('password', value.senha);

      httpId
        .post('connect/token', data)
        .then(async (response) => {
          const auth = { ...response.data };
          try {
            const decoded = jwt.decode(response.data.access_token) || {};
            auth.full_name = decoded.full_name;
            auth.email = decoded.email;
            auth.email_confirmed = decoded.email_confirmed;
            auth.uid = decoded.uid;
          } catch (e) {
            void e;
          }
          commit('SET_AUTH', auth);
          commit('SET_LOGIN_LOADING');
          commit('SET_LOGIN_ERROR', '');
          commit('SET_MENSAGEM', '');
          commit('SET_REGISTER_COMPLETED', true);
          resolve({ success: true });
        })
        .catch((error) => {
          commit('SET_LOGIN_LOADING');
          const resp = error?.response?.data || {};
          const message = resp?.error_description || resp?.message || error?.message;
          const hasMfaFlag = resp?.mfa_required === true || resp?.mfaRequired === true;
          const hasMfaError =
            resp?.error === 'mfa_required' ||
            resp?.error_code === 'mfa_required' ||
            (resp?.error_description && typeof resp.error_description === 'string' && resp.error_description.toLowerCase().includes('mfa'));
          if (resp && (hasMfaFlag || hasMfaError)) {
            resolve({ mfaRequired: true });
            return;
          }
          if (message === 'invalid_username_or_password') commit('SET_LOGIN_ERROR', 'Email ou senha inválidos');
          else commit('SET_LOGIN_ERROR', message || 'Erro ao autenticar');
          reject(error);
        });
    });
  },

  async setLoginWithOtp({ commit }, value) {
    return new Promise((resolve, reject) => {
      const data = new URLSearchParams();
      data.append('client_id', 'site-eblonline');
      data.append('client_secret', '8FM48ML0gL8ulcME9uGk36uPgmQDGJJx');
      data.append('grant_type', 'password');
      data.append('username', value.nomeUsuario);
      data.append('password', value.senha);
      if (value.otp) {
        data.append('otp', value.otp);
      }
      if (value.recoveryCode) {
        data.append('recovery_code', value.recoveryCode);
      }

      httpId
        .post('connect/token', data)
        .then(async (response) => {
          const auth = { ...response.data };
          try {
            const decoded = jwt.decode(response.data.access_token) || {};
            auth.full_name = decoded.full_name;
            auth.email = decoded.email;
            auth.email_confirmed = decoded.email_confirmed;
            auth.uid = decoded.uid;
          } catch (e) {
            void e;
          }
          commit('SET_AUTH', auth);
          commit('SET_LOGIN_ERROR', '');
          commit('SET_MENSAGEM', '');
          commit('SET_REGISTER_COMPLETED', true);

          try {
            var oldInfoEnabled = store.getters['getUsuarioInfo'] || store.state.cadastro?.usuarioInfo || {};
            if (oldInfoEnabled && typeof oldInfoEnabled === 'object') {
              var newInfoEnabled = Object.assign({}, oldInfoEnabled, { mfaEnabled: true });
              store.commit('SET_USUARIO_INFO', newInfoEnabled);
            }
          } catch (_) {
            void _;
          }

          resolve({ success: true });
        })
        .catch((error) => {
          const resp = error?.response?.data;
          const message = resp?.error_description || resp?.message || error?.message;
          const errorCode = resp?.error_code || resp?.ErrorCode;
          if (errorCode !== 'invalid_otp' && errorCode !== 'invalid_recovery_code') {
            if (message === 'invalid_username_or_password') commit('SET_LOGIN_ERROR', 'Email ou senha inválidos');
            else commit('SET_LOGIN_ERROR', message || 'Erro ao autenticar');
          }
          reject(error);
        });
    });
  },

  refreshToken({ commit, state }, value) {
    //console.log(value);
    const data = new URLSearchParams();
    data.append('client_id', 'site-eblonline');
    data.append('client_secret', '8FM48ML0gL8ulcME9uGk36uPgmQDGJJx');
    data.append('grant_type', 'refresh_token');
    data.append('refresh_token', value);

    httpId.post('connect/token', data).then(async (response) => {
      const auth = {
        ...state.auth,
        access_token: response.data.access_token
      };
      commit('SET_AUTH', auth);
    });
  },
  checkRegisterCompleted({ commit }) {
    return new Promise((resolve, reject) => {
      http({
        url: `usuario/info`,
        method: 'get'
      })
        .then((resp) => {
          if (!resp.data.data.ativo && resp.data.data.cadastroCompleto) {
            commit('SET_AUTH');
          }
          commit('SET_USUARIO_INFO', resp.data.data);
          commit('SET_REGISTER_COMPLETED', resp.data.data.cadastroCompleto);
          resolve(resp.data.data);
        })
        .catch(() => reject(false));
    });
  },
  validateMfaSocial(_, value) {
    return new Promise((resolve, reject) => {
      http.post('usuario/Mfa/Validate', { code: value.code })
        .then((response) => {
          if (response.data.succeeded) {
            resolve({ success: true });
          } else {
            reject(new Error(response.data.message || 'Código inválido'));
          }
        })
        .catch((error) => {
          const message = error?.response?.data?.message || error?.message || 'Erro ao validar código';
          reject(new Error(message));
        });
    });
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};
